import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material';
import React from 'react';

const WORKSPACES = [
  { value: 'rawData', label: 'Raw Data' },
  { value: 'o2kinetics', label: 'O₂ Kinetics' },
];

/**
 * Workspace switcher — toggles between Raw Data and O2 Kinetics (and future workspaces).
 * Rendered inside each analysis panel, below the tab.
 */
const WorkspaceSelector = ({ value, onChange }) => {
  return (
    <Box
      sx={{
        height: '72px',
        borderTop: '1px solid #9BACB3',
        boxShadow: 'inset 0 1px 0 0 #F5F5F5',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <ToggleButtonGroup
        value={value}
        exclusive
        onChange={(_, newValue) => {
          if (newValue !== null) onChange(newValue);
        }}
        sx={{
          '& .MuiToggleButton-root': {
            textTransform: 'none',
            height: '54px',
            width: '200px',
            fontSize: 12,
            fontWeight: 500,
            color: '#394b57',
            borderColor: 'rgba(0,0,0,0.15)',
            '&.Mui-selected': {
              bgcolor: '#394b57',
              color: '#fff',
              '&:hover': { bgcolor: '#3C5462' },
            },
          },
        }}
      >
        {WORKSPACES.map((ws) => (
          <ToggleButton key={ws.value} value={ws.value}>
            {ws.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Box>
  );
};

export default WorkspaceSelector;
